function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSecuritiStacked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#1EA8DC"
    },
    d: "M17.2,4.3c-3.5-1.2-6.8,2.1-5.7,5.6l1.9,5.6 c0.3,0.9,0.3,1.9,0,2.8l-1.9,5.6c-1.2,3.5,2.1,6.8,5.7,5.7l5.7-1.9c0.9-0.3,1.9-0.3,2.8,0l5.6,1.9c3.5,1.1,6.8-2.2,5.6-5.7L35,18.5 c-0.3-0.9-0.3-1.9,0-2.9l1.9-5.7c1.2-3.5-2.2-6.8-5.7-5.7l-5.6,1.9c-0.9,0.3-1.9,0.3-2.9,0L17.2,4.3z M24.2,23.8 c1.8,0,3.5-0.7,4.8-2c1.3-1.3,2-3,2-4.8s-0.7-3.5-2-4.8c-1.3-1.3-3-2-4.8-2s-3.5,0.7-4.8,2s-2,3-2,4.8s0.7,3.5,2,4.8 S22.3,23.8,24.2,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1EA8DC"
    },
    d: "M22.1,19c0.3,0.3,0.6,0.5,0.9,0.6c0.4,0.1,0.7,0.2,1.1,0.2c0.4,0,0.7-0.1,1.1-0.2 c0.4-0.1,0.6-0.4,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.4,0.2-0.7,0.2-1.1c0-0.4-0.1-0.7-0.2-1.1c-0.1-0.4-0.4-0.6-0.6-0.9 c-0.5-0.5-1.3-0.8-2-0.8s-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.3-0.8,2C21.3,17.8,21.6,18.5,22.1,19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M9,39.1c-0.1-1.5-1.4-1.9-2.3-1.9c-1.2,0-2.3,0.8-2.3,2c0,0.9,0.7,1.4,1.6,1.7 c1.2,0.4,1.7,0.6,1.7,1.1c0,0.4-0.4,0.7-0.9,0.7c-0.3,0-0.9-0.1-0.9-0.8H4.4c0.1,1.5,1.5,2,2.4,2c1.3,0,2.4-0.8,2.4-2.1 c0-1.4-1.1-1.7-2.1-1.9C6.4,39.7,6,39.5,6,39.1c0-0.3,0.3-0.6,0.7-0.6c0.6,0,0.8,0.4,0.8,0.7L9,39.1L9,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M16.4,41.1c0.1-1.1-0.2-2.1-0.9-2.9c-0.6-0.6-1.4-1-2.4-1c-1.9,0-3.3,1.6-3.3,3.4s1.4,3.3,3.4,3.3 c0.6,0,1.3-0.2,1.8-0.6c0.5-0.4,1-0.9,1.3-1.6h-1.6c-0.3,0.5-0.8,0.8-1.5,0.8c-0.9,0-1.8-0.6-1.9-1.6H16.4z M11.3,39.9 c0.1-0.6,0.7-1.4,1.8-1.4s1.8,0.8,1.8,1.4H11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M22.1,41.5c-0.2,0.5-0.8,1.1-1.7,1.1c-1.1,0-1.9-0.8-1.9-1.9c0-0.6,0.2-1.1,0.5-1.4 c0.4-0.4,0.8-0.6,1.4-0.6c0.8,0,1.5,0.5,1.7,1.1h1.6c-0.4-1.6-1.7-2.6-3.3-2.6c-1.9,0-3.3,1.5-3.3,3.4c0,1.8,1.4,3.4,3.4,3.4 c1.7,0,2.9-1.1,3.3-2.5L22.1,41.5L22.1,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M30.5,37.4h-1.5v3.5c0,0.9-0.4,1.6-1.5,1.6c-1.1,0-1.4-0.7-1.4-1.7v-3.5h-1.5v3.8 c0,1.1,0.4,2.7,2.5,2.7c1.1,0,1.7-0.6,2-1v0.8h1.4V37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M31.7,43.8h1.5v-3.4c0-1.1,0.6-1.6,1.6-1.6h0.1v-1.5c-1,0-1.5,0.5-1.8,1v-0.8h-1.4L31.7,43.8 L31.7,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M35.6,36.6h1.5v-1.4h-1.5V36.6z M35.6,43.8h1.5v-6.4h-1.5V43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M38.8,43.8h1.5v-5.2h1.1v-1.2h-1.1v-2.2h-1.5v2.2h-1v1.2h1.1L38.8,43.8L38.8,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E2229"
    },
    d: "M42.1,36.6h1.5v-1.4h-1.5V36.6z M42.1,43.8h1.5v-6.4h-1.5V43.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSecuritiStacked);
export default __webpack_public_path__ + "static/media/logo-securiti-stacked.d6140beb.svg";
export { ForwardRef as ReactComponent };